var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import parseURL from "url-parse";
import { parseVNextApiError, getApiErrorType } from "@ane/core/lib/utils/ErrorUtils";
import { setAuthHeader } from "./utils.js";
import Logger from "@ane/core/lib/services/logging/Logger";
import { getNewGuid } from "@ane/core/lib/utils/CommonStringUtils";
import { WorkspaceMigrationStatusCodes } from "@ane/core/lib/models/IAsyncWrapper/WorkspaceMigrationModels";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { isMigrationErrorStatusCode } from "@ane/core/lib/utils/WorkspaceMigration.utils";
import { AsyncRequestStatus } from "@ane/core/lib/models";
import { isUsingWPSWorkspaceAndProxyEnabled, transformPathToId } from "@ane/core/lib/utils/WPSUtils";
const applyWPSProxyUrl = (baseUrl) => {
  if (!isUsingWPSWorkspaceAndProxyEnabled()) {
    return baseUrl;
  }
  const wpsStatus = EnvironmentService.getWpsStatus();
  const workspaceId = wpsStatus.wpsWorkspaceId;
  const experimentGroupNameOrID = wpsStatus.experimentGroup;
  const url = parseURL(baseUrl);
  const targetUrl = (url == null ? void 0 : url.host) + (url == null ? void 0 : url.pathname) + (url == null ? void 0 : url.query);
  let experimentGroupSubPath = "";
  if (experimentGroupNameOrID) {
    let experimentGroupId = transformPathToId(experimentGroupNameOrID);
    experimentGroupSubPath = `/experimentation-group/${experimentGroupId}`;
  }
  return `${EnvironmentService.endpoints.wps.url}/workspace/${workspaceId}${experimentGroupSubPath}/proxy/${targetUrl}`;
};
const applyAdapterUrl = (baseUrl) => {
  if (!EnvironmentService.isUnifiedView) {
    return baseUrl;
  }
  return EnvironmentService.endpoints.expmanAdapter.url;
};
const getExpApiBaseQueryWithBaseUrl = (baseUrlInput = EnvironmentService.endpoints.default.url, useAdapter = true, useWPSProxy = true) => (args, api, extraOptions) => __async(void 0, null, function* () {
  let baseUrl = baseUrlInput;
  if (useAdapter) {
    baseUrl = applyAdapterUrl(baseUrl);
  }
  if (useWPSProxy) {
    baseUrl = applyWPSProxyUrl(baseUrl);
  }
  const rawBaseQuery = fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => __async(void 0, null, function* () {
      yield setAuthHeader({ tokenScope: EnvironmentService.endpoints.default.tokenScope }, headers);
      headers.set("Cache-Control", "no-cache");
      return headers;
    })
  });
  return rawBaseQuery(args, api, extraOptions);
});
const expApiBaseQuery = getExpApiBaseQueryWithBaseUrl();
const getLoggerBaseQuery = (baseQueryFn, logger = Logger) => (args, api, extraOptions) => __async(void 0, null, function* () {
  var _a, _b, _c, _d, _e;
  const correlationId = getNewGuid();
  if (typeof args !== "string") {
    args.headers = __spreadProps(__spreadValues({}, args.headers), {
      "X-Correlation-Id": correlationId
    });
  }
  let result = yield baseQueryFn(args, api, extraOptions);
  if (!result.error) {
    return result;
  }
  if (typeof result.error.status === "number" && typeof result.error.data === "object") {
    const apiError = (_c = parseVNextApiError((_b = (_a = result.error.data) == null ? void 0 : _a.error) != null ? _b : result.error.data)) != null ? _c : {
      message: "An unknown error occurred.",
      code: "UNKNOWN"
    };
    let errorContext = {
      correlationId,
      type: getApiErrorType(result.error.status),
      statusCode: result.error.status,
      displayError: apiError.message
    };
    if (result.error.status === WorkspaceMigrationStatusCodes.MethodNotAllowed) {
      (_d = errorContext.displayError) != null ? _d : errorContext.displayError = EnvironmentService.wsplitMethodNotAllowedText();
    }
    if (result.error.status === WorkspaceMigrationStatusCodes.NotAcceptable) {
      (_e = errorContext.displayError) != null ? _e : errorContext.displayError = EnvironmentService.wsplitNotAcceptableText();
    }
    result.error.data = __spreadProps(__spreadValues({}, apiError), {
      errorContext
    });
    if (isMigrationErrorStatusCode({
      data: result.data,
      status: AsyncRequestStatus.Failed,
      errorContext
    })) {
      logger.warn(errorContext.displayError, {
        isWorkspaceMigration: true,
        correlationId
      });
    }
  }
  logger.log("fetch_error", {
    args,
    error: result.error,
    correlationId
  });
  return result;
});
export {
  applyAdapterUrl,
  applyWPSProxyUrl,
  expApiBaseQuery,
  getExpApiBaseQueryWithBaseUrl,
  getLoggerBaseQuery
};
//# sourceMappingURL=common.js.map
